module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (114).caf70b04.jpg";